import { useEffect, type ReactNode } from "react";

/** Right-side detail panel for row drill-down. */
export default function Drawer({
  open,
  title,
  subtitle,
  onClose,
  children,
  footer,
}: {
  open: boolean;
  title: string;
  subtitle?: ReactNode;
  onClose: () => void;
  children: ReactNode;
  footer?: ReactNode;
}) {
  useEffect(() => {
    if (!open) return;
    const onKey = (event: KeyboardEvent) => {
      if (event.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;
  return (
    <div className="ui-drawer-root">
      <div className="ui-drawer-backdrop" onClick={onClose} aria-hidden="true" />
      <aside className="ui-drawer" role="dialog" aria-modal="true" aria-label={title}>
        <header className="ui-drawer-header">
          <div>
            <div className="ui-drawer-title">{title}</div>
            {subtitle ? <div className="ui-drawer-subtitle">{subtitle}</div> : null}
          </div>
          <button type="button" className="ui-drawer-close" onClick={onClose} aria-label="닫기">
            ✕
          </button>
        </header>
        <div className="ui-drawer-body">{children}</div>
        {footer ? <footer className="ui-drawer-footer">{footer}</footer> : null}
      </aside>
    </div>
  );
}

/** Definition list used inside drawers. */
export function DetailList({ items }: { items: Array<[string, ReactNode]> }) {
  return (
    <dl className="ui-detail-list">
      {items.map(([label, value]) => (
        <div className="ui-detail-row" key={label}>
          <dt>{label}</dt>
          <dd>{value}</dd>
        </div>
      ))}
    </dl>
  );
}
